import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Sitewide empty-state cluster. Mirrors the profile/dashboard empty states
// EXACTLY so every empty state reads the same: a muted glyph in a grey circle,
// a bold title, and a grey body — a centered cluster. Only the glyph and copy
// change per usage. (Reference: Profile posts empty state.)
//
// House rule: NO trailing punctuation in the title; punctuation IS used in body.
// Glyph family: FontAwesome free-regular (outline), matching the existing ones.
// `className` only exists to let a caller neutralise the default asymmetric
// pt-6/pb-16 (use `!pt-0 !pb-0`) when the cluster has to sit dead-centre in a
// tall panel rather than below content. Everything inside — glyph, circle, their
// dimensions, the headline and body styles, and the spacing between them — is
// fixed here so every empty state in the app is identical.
export default function EmptyState({ icon, title, body, className = "" }) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center pt-6 pb-16 px-6 ${className}`}
    >
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#F3F4F6]">
        <FontAwesomeIcon icon={icon} className="text-xl text-[#9CA3AF]" />
      </span>
      <p className="text-lg font-bold text-gray-900">{title}</p>
      <p className="mt-1 max-w-xs text-sm text-gray-500">{body}</p>
    </div>
  );
}
